import { z } from 'zod';

export const automationTriggerSchema = z.enum([
  'shopify_order_paid',
  'shopify_abandoned_cart',
  'stripe_invoice_payment_failed',
  'webhook_generic',
  'sheet_row_added',
  'onboarding_drip',
]);

export const automationSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  triggerType: automationTriggerSchema,
  isActive: z.boolean(),
  lastRunAt: z.string().datetime().nullable(),
  totalRuns: z.number().int().nonnegative().default(0),
  templateId: z.string().uuid().nullable(),
  n8nWorkflowId: z.string().nullable(),
});

export const createAutomationSchema = z.object({
  name: z.string().min(1).max(120),
  triggerType: automationTriggerSchema,
  templateId: z.string().uuid(),
  config: z.record(z.unknown()).default({}),
});

export type AutomationTrigger = z.infer<typeof automationTriggerSchema>;
export type Automation = z.infer<typeof automationSchema>;
export type CreateAutomationInput = z.infer<typeof createAutomationSchema>;
